// extracted by mini-css-extract-plugin
module.exports = {"blockstyle":"style_blockstyle__-nJNq","blocktitle":"style_blocktitle__2zdna","code":"style_code__XpL3m"};